module.exports = __webpack_public_path__ + "static/media/2.0639c88f.mp3";